<template>
  <div class="content-wrapper summary-results pt-4">
      <div
        id="configuration_id_wrapper"
        style="text-align: right; font-style: italic; display: none;"
      ></div>
      <div class="center">
        <div class="container" style="position: relative">
          <div class="xs-text uppercase">Introducing your custom</div>
          <h3 class="mt-3">{{ bike && bike.name ? bike.name : "" }}</h3>
          <h4 v-if="displayConfigurationId" class="mt-3">
            Configuration #{{ displayConfigurationId }}
          </h4>

          <div class="info-items d-flex justify-content-between mt-5 pdf-item">
          <div class="info-item" v-if="getCustomerReferenceLabel()">
              <div class="xs-text uppercase mb-1">Customer reference</div>
              <h5 class="info-item-title">{{ getCustomerReferenceLabel() }}</h5>
          </div>
          <div class="info-item" v-if="bike">
              <div class="xs-text uppercase mb-1">Material</div>
              <h5 class="info-item-title">{{ getMaterialNameById(bike.material_id) }}</h5>
          </div>
          <div class="info-item" v-if="bike && bike.frame_weight != null">
              <div class="xs-text uppercase mb-1">Frame weight</div>
              <h5 class="info-item-title">{{ bike.frame_weight }}Kg</h5>
          </div>
          <div class="info-item">
              <div class="xs-text uppercase mb-1">Total inc. accessories</div>
              <h5 class="info-item-title">{{ formatPrice(price) }}<a href="#price_asterisc">*</a></h5>
          </div>
          <div
              class="info-item"
              v-if="
              results.colour.primaryColor != null ||
              results.colour.secondaryColor != null
              "
          >
              <div class="xs-text uppercase mb-1">Colour</div>
              <h5 class="info-item-title">
              {{ results.colour.primaryColor }}
              <span v-if="results.colour.secondaryColor != null">/</span>
              {{ results.colour.secondaryColor }}
              </h5>
          </div>
          <div
              class="info-item"
              v-if="
              results.frame.finish != null && results.frame.finish.name != null
              "
          >
              <div class="xs-text uppercase mb-1">Frame finish</div>
              <h5 class="info-item-title">{{ results.frame.finish.name }}</h5>
          </div>
          </div>

          <div
          class="frame-text-wrapper"
          v-if="
              results.frame.finish != null &&
              results.frame.title.text != null &&
              results.frame.title.family != null
          "
          >
          <div class="info-item" v-if="results.frame.finish.name != null">
              <div class="xs-text uppercase mb-1">Personal title</div>
              <h5 class="info-item-title">
              <span
                  :style="{
                  'font-family': results.frame.title.family.font,
                  'font-weight': results.frame.title.family.bold
                      ? '600'
                      : '400',
                  'font-style': results.frame.title.family.italic
                      ? 'italic'
                      : 'none',
                  'text-transform': results.frame.title.family.uppercase
                      ? 'uppercase'
                      : 'none',
                  }"
                  >"{{ results.frame.title.text }}"</span
              >
              </h5>
          </div>
          </div>

          <buttonset
          class="no-print"
          :loggedUser="loggedUser"
          :isAdmin="isAdmin"
          :configurationIsConfirmed="configurationIsConfirmed"
          :configurationId="configurationId"
          :configurationIsDefaultSlot="configurationIsDefaultSlot"
          v-on:save-configuration="saveConfiguration"
          v-on:save-configuration-delete-origin-after-send="saveConfigurationDeleteOriginAfterSend"
          v-on:save-draft-configuration="saveDraftConfiguration"
          v-on:download-configuration="downloadConfiguration"
          v-on:ask-information="askInformation"
          v-on:confirm-configuration="confirmConfiguration"
          v-on:edit-configuration="editConfiguration"
          v-on:edit-configuration-replace="editConfigurationReplace"
          v-on:save-configuration-as-default="saveConfigurationAsDefault"
          v-on:configure-another-bike="configureAnother"
          ></buttonset>

          <div class="imager-wrapper pdf-item no-print">
          <imagerComponent
              :results="results"
              :bikeConfiguration="bikeConfiguration"
              :componentsConfig="componentsConfig"
              :where="'result'"
          ></imagerComponent>
          </div>

          <div
          id="bike_image_pdf"
          class="imager-wrapper pdf-item avoid"
          style="display: none"
          >
          <img :src="bikeImage" style="max-height: 400px; max-width: 100%" />
          </div>
        </div>

        <div class="html2pdf__page-break"></div>

        <div class="specifications" v-if="mews.length > 0">
          <h3 class="specification-title">Your specification</h3>
          <div class="components">
            <div
              class="components-container"
              v-for="(row, rowNum) in mews"
              :key="rowNum"
            >
              <div
                v-if="rowNum % 2 == 0 && rowNum != 0"
                class="html2pdf__page-break"
              />
              <h3 class="specification-title print" style="display: none;" v-if="rowNum % 2 == 0 && rowNum != 0">Your specification</h3>
              <div class="pdf-item specification-row">
                <div
                  class="component"
                  v-for="(item, index) in row"
                  :key="index"
                >
                  <div class="component-card">
                    <div class="uppercase xs-text">
                      {{ item.key == "tyres" ? "tires" : item.key }}
                    </div>
                    <h5 class="mt-2 mb-4 info-item-title">
                      {{ item.data.name }}
                      <span v-if="item.data.measure"
                        >({{ item.data.measure }})</span
                      >
                    </h5>
                    <div
                      class="image"
                      v-if="item.data.image != null"
                      v-on:click="editComponent(item.key)"
                    >
                      <img :src="'/storage/' + item.data.image" />
                    </div>
                    <div
                      class="image"
                      :style="{
                        'background-image':
                          'url(/configurator/component-placeholder.png)',
                        'background-size': '120px',
                      }"
                      v-else
                      v-on:click="editComponent(item.key)"
                    ></div>
                    <div class="no-print">
                      <small>Click on image to edit component</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <buttonset
          class="no-print"
          v-if="mews.length > 0"
          :loggedUser="loggedUser"
          :isAdmin="isAdmin"
          :configurationIsConfirmed="configurationIsConfirmed"
          :configurationId="configurationId"
          :configurationIsDefaultSlot="configurationIsDefaultSlot"
          v-on:save-configuration="saveConfiguration"
          v-on:save-configuration-delete-origin-after-send="saveConfigurationDeleteOriginAfterSend"
          v-on:save-draft-configuration="saveDraftConfiguration"
          v-on:download-configuration="downloadConfiguration"
          v-on:confirm-configuration="confirmConfiguration"
          v-on:edit-configuration="editConfiguration"
          v-on:edit-configuration-replace="editConfigurationReplace"
          v-on:ask-information="askInformation"
          v-on:configure-another-bike="configureAnother"
        ></buttonset>

        <div v-if="mews % 2 !== 0" class="html2pdf__page-break"></div>

        <div id="price_asterisc">
          * All prices displayed on our website are meant for direct clients of Passoni Titanio Societa Benefit s.r.l., with VAT included at the Italian rate. We operate a point of sale at our Atelier in Vimercate (Milano). Shipping costs and any applicable local duties will be calculated with our clients for each project, depending on delivery method and timing.
        </div>
        <div id="social-info">
          Congratulations on choosing Passoni for your made-to-measure bike.
          <br />
          This PDF is your guide to our powerful configurator, where you can
          customize every detail of your dream bicycle. <br />
          Discover a range of options tailored to your preferences and riding
          style. From frame geometry to finishes, create a truly unique
          masterpiece that reflects your passion. <br />
          Our intuitive instructions and visuals make the configurator easy to
          use. Our experts are here to assist you, ensuring a seamless and
          enjoyable experience. For any further information or inquiries about
          the configuration process, please email us at info@passoni.it. <br />
          Stay connected with us on Instagram and Facebook to join our
          passionate cycling community and stay updated on the latest news and
          inspirations. <br />
          The Passoni Team <br />
          Follow us: <br />
          Instagram: @passoni_titanio <br />
          Facebook: PassoniBikes
        </div>
        <div class="footer no-print">
          <div class="row">
            <div class="col-md-4">
              <h5>Customer service</h5>
              <ul>
                <li>
                  <a target="_blank" href="https://passoni.com/delivery"
                    >Delivery</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://passoni.com/storage/documents/PASSONIRETURN.pdf"
                    >Returns &amp; exchanges</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://passoni.com/privacy-policy"
                    >Privacy policy</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://passoni.com/terms-and-conditions"
                    >Terms &amp; conditions</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-md-4 align-self-center">
              <img
                src="https://passoni.com/themes/passoni/assets/images/icons/logo-brand.svg"
                alt="Logo Passoni"
                class="icons-dark"
              />
            </div>
            <div class="col-md-4">
              <h5>Connect with Passoni</h5>
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/passoni_titanio/"
                    >Instagram</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://facebook.com/PassoniBikes"
                    >Facebook</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.strava.com/clubs/passoni-31360"
                    >Strava</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.flickr.com/photos/passoni/"
                    >Flickr</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://vimeo.com/passoni">Vimeo</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://it.linkedin.com/in/passoni-titanio-1a632ba8"
                    >Linkedin</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import imagerComponent from "../../shared/imager.vue";
import buttonset from "./buttonset.vue";

export default {
  name: "summary-results",
  data() {
    return {
      currentPDFi: 1,
    };
  },
  props: [
    "bike",
    "results",
    "price",
    "measures",
    "componentsConfig",
    "bikeConfiguration",
    "loggedUser",
    "bikeImage",
    "isAdmin",
    "customerReferenceLabel",
    "configurationId",
    "configurationIsConfirmed",
    "configurationIsDefaultSlot",
  ],
  components: {
    imagerComponent,
    buttonset,
  },
  computed: {
    mews() {
      var inputArray = Object.keys(this.results)
        .map((key) => {
          if (key != "frame" && key != "colour" && key != "colours") {
            return { data: this.results[key], key: key };
          }
        })
        .filter(function (e) {
          if (e != null && e.data != null && e.data.id != -1) {
            return e;
          }
        });
      var perChunk = 3; // items per chunk

      var result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },
    displayConfigurationId() {
      if (this.configurationId != null && this.configurationId !== "") {
        return String(this.configurationId);
      }
      if (typeof window === "undefined") return null;
      try {
        const params = new URLSearchParams(window.location.search.substring(1));
        const load = params.get("load");
        if (load) return load;
      } catch (e) {}
      try {
        return (
          window.localStorage.getItem("preconfiguration-stored") ||
          window.localStorage.getItem("preconfiguration-id") ||
          null
        );
      } catch (e) {
        return null;
      }
    },
  },
  methods: {
    getMaterialNameById(id) {
      if (id == 2) {
        return "Carbo-Titanium";
      }
      if (id == 4) {
        return "Titanium";
      }
      if (id == 5) {
        return "Carbon";
      }
      if (id == 6) {
        return "Stainless Steel";
      }
      if (id == 7) {
        return "Carbo-Titanium";
      }
      return null;
    },
    formatPrice: function () {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",

        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
      return formatter.format(this.price);
    },
    saveConfiguration: function () {
      this.$emit("save-configuration");
    },
    saveConfigurationDeleteOriginAfterSend: function () {
      this.$emit("save-configuration-delete-origin-after-send");
    },
    saveDraftConfiguration: function () {
      this.$emit("save-draft-configuration");
    },
    downloadConfiguration: function () {
      this.$emit("download-configuration");
    },
    askInformation: function () {
      this.$emit("ask-information");
    },
    confirmConfiguration: function () {
      this.$emit("confirm-configuration");
    },
    editConfiguration: function () {
      this.$emit("edit-configuration");
    },
    editConfigurationReplace: function () {
      this.$emit("edit-configuration-replace");
    },
    editComponent: function (type) {
      this.$emit("edit-single-component", type);
    },
    configureAnother: function () {
      this.$emit("configure-another-bike");
    },
    saveConfigurationAsDefault: function (n) {
      this.$emit("save-configuration-as-default", n);
    },
    getCustomerReferenceLabel() {
      // Prefer the prop coming from the parent (when available).
      if (
        this.customerReferenceLabel &&
        typeof this.customerReferenceLabel === "string" &&
        this.customerReferenceLabel.trim() !== ""
      ) {
        return this.customerReferenceLabel.trim();
      }

      // Fallback to what we stored locally when saving.
      try {
        const stored = window.localStorage.getItem(
          "customerReferenceLabel"
        );
        if (stored && stored.trim() !== "") {
          return stored.trim();
        }
      } catch (e) {
        // ignore
      }

      return null;
    },
  },
  mounted: function () {
    // Generate bike png
    if (this.bikeImage == null) {
      let t = this;
      setTimeout(function () {
        // t.$emit("generate-bike-image");
      }, 800);
    }
  },
};
</script>

<style lang="scss" scoped>
.before {
  page-break-before: always;
}
.after {
  page-break-after: always;
}
.avoid {
  page-break-inside: avoid;
}
.summary-results {
  .info-items {
    max-width: 860px;
    margin: 0 auto;

    .info-item {
      width: 19%;
      text-align: center;

      .info-item-title {
        font-size: 14px;
      }
    }
  }
  .imager-wrapper {
    /*max-width: 800px;*/
    margin: auto;
  }

  .black-bottom-border {
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }

  .components {
    background: #fff;
    padding-top: 14px;
    padding-left: 14px;
    padding-right: 16px;
    margin-left: -42px;
    margin-right: -42px;

    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0;
    }

    .specification-row {
      margin-left: 0;
      margin-right: 0;
      display: flex;
      flex-wrap: wrap;
    }

    .component {
      display: flex;
      margin-bottom: 14px;
      width: 33.3%;

      &:nth-child(1) {
        border-right: 7px solid #fff;
      }

      &:nth-child(2n) {
        border-left: 7px solid #fff;
        border-right: 7px solid #fff;
      }

      &:nth-child(3n) {
        border-left: 7px solid #fff;
      }

      @media print, (max-width: 767px) {
        width: 100%;
        &:nth-child(1) {
            border-right: 0;
        }

        &:nth-child(2n) {
            border-left: 0;
            border-right: 0;
        }

        &:nth-child(3n) {
            border-left: 0;
        }
      }

      .component-card {
        background-color: #fff;
        padding: 28px 14px;
        width: 100%;
        border: 1px solid #6c757d;
      }

      h5 {

        @media (max-width: 767px) {
          font-size: 16px;
        }
      }

      .image {
        width: 100%;
        background-size: 90%;
        background-position: center center;
        background-repeat: no-repeat;
        height: 300px;
        overflow: hidden;
        cursor: pointer;
        padding: 42px;

        @media (max-width: 767px) {
          height: 300px;
          padding: 14px;
        }
      }
    }
  }

  .footer {
    padding: 60px 0;
    border-top: 1px solid black;
    margin-top: 100px;

    ul {
      margin-top: 20px;
      padding-left: 0;
      list-style: none;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 50%;
        text-transform: uppercase;
        font-size: 11px;
        margin-bottom: 10px;
      }
    }

    img {
      max-width: 100px;
    }
  }
}

.image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

#price_asterisc,
#social-info {
  margin-top: 50px;
  text-align: left;
  padding: 0 15px;
}

.specifications {
    margin-top: 3rem;

  @media (max-width: 767px) {
    margin-bottom: 0 !important;
  }
}

.info-item-title {
  font-family: 'Avenir-Book';
  letter-spacing: 0;
}
</style>
